import React from 'react';
import { Button } from './ui/button';
import { Rocket } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const CTASection = () => {
  const { login } = useAuth();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-[#1a1a2e] mb-8 flex items-center justify-center gap-4 flex-wrap">
          Teste grátis por
          <span className="inline-flex">
            <Rocket className="h-12 w-12 text-[#f97316]" />
          </span>
          7 dias.
        </h2>
        <Button
          size="lg"
          onClick={login}
          className="rounded-full bg-[#3b82f6] hover:bg-[#2563eb] text-white text-lg px-10 py-6 h-auto shadow-lg hover:shadow-xl transition-all"
        >
          Começar grátis
        </Button>
      </div>
    </section>
  );
};

export default CTASection;
